import * as i0 from '@angular/core';
import { model, input, signal, computed, output, viewChild, effect, Component, ChangeDetectionStrategy } from '@angular/core';
import { NgStyle } from '@angular/common';
import * as i1 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { fromEvent, map, debounceTime, distinctUntilChanged } from 'rxjs';
import { NgxSkeletonLoadingComponent } from '@digipay/ngx-skeleton-loading';
import { toObservable } from '@angular/core/rxjs-interop';
import { NgxIcon } from '@digipay/ngx-icon';
const _c0 = ["searchEl"];
const _c1 = ["focusButton"];
const _c2 = a0 => ({
  height: a0
});
function NgxSearchBoxComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵlistener("click", function NgxSearchBoxComponent_Conditional_0_Conditional_1_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.leadingIconClicked.emit());
    });
    i0.ɵɵelement(1, "ngx-icon", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("iconSize", "20px")("name", ctx_r1.leadingIcon())("type", "linear");
  }
}
function NgxSearchBoxComponent_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵlistener("click", function NgxSearchBoxComponent_Conditional_0_Conditional_5_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleClickOnTrailingIcon());
    });
    i0.ɵɵelement(1, "ngx-icon", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("iconSize", "20px")("name", ctx_r1.trailingIcon())("type", "linear");
  }
}
function NgxSearchBoxComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵlistener("click", function NgxSearchBoxComponent_Conditional_0_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clicked.emit());
    });
    i0.ɵɵtemplate(1, NgxSearchBoxComponent_Conditional_0_Conditional_1_Template, 2, 3, "div", 3);
    i0.ɵɵelementStart(2, "div", 4)(3, "input", 5, 0);
    i0.ɵɵtwoWayListener("ngModelChange", function NgxSearchBoxComponent_Conditional_0_Template_input_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.tempSearchText, $event) || (ctx_r1.tempSearchText = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, NgxSearchBoxComponent_Conditional_0_Conditional_5_Template, 2, 3, "div", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 7, 1);
    i0.ɵɵlistener("click", function NgxSearchBoxComponent_Conditional_0_Template_button_click_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onFocusClicked());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(8, _c2, ctx_r1.height()));
    i0.ɵɵadvance();
    i0.ɵɵconditional(1, ctx_r1.leadingIcon() ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("search-container-inputbox-input border-300 radius-giant d-flex align-items-center justify-content-start b-2 text-onback-high ", ctx_r1.mode(), "");
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.tempSearchText);
    i0.ɵɵproperty("placeholder", ctx_r1.placeHolder());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(5, ctx_r1.trailingIcon() ? 5 : -1);
  }
}
function NgxSearchBoxComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelement(1, "lib-ngx-skeleton-loading", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("height", ctx_r1.height())("classes", "radius-giant");
  }
}
let NgxSearchBoxComponent = /*#__PURE__*/(() => {
  class NgxSearchBoxComponent {
    constructor(ngZone) {
      this.ngZone = ngZone;
      this.searchText = model('');
      this.isLoading = input(false);
      this.debounceTime = input(800);
      this.mode = input('page');
      this.placeHolder = input('جست‌وجو');
      this.autoFocus = input(false);
      this.tempSearchText = signal('');
      this.height = input('48px');
      this.leadingIcon = input('search');
      this.trailingIcon = computed(() => {
        return this.tempSearchText() ? 'close' : '';
      });
      this.leadingIconClicked = output();
      this.trailingIconClicked = output();
      this.clicked = output();
      this.searchEnd = output();
      this.searchEl = viewChild('searchEl');
      this.focusButton = viewChild('focusButton');
      this.initialized = false;
      effect(() => {
        if (this.autoFocus()) {
          this.focusButton()?.nativeElement.click();
        }
      });
      toObservable(this.searchText).subscribe(newSearchText => {
        this.tempSearchText.set(newSearchText);
      });
      toObservable(this.isLoading).subscribe(loading => {
        if (!loading) {
          this.initializeSearch();
        }
      });
    }
    ngAfterViewChecked() {
      this.initializeSearch();
    }
    initializeSearch() {
      if (this.searchEl()?.nativeElement && !this.initialized) {
        this.ngZone.runOutsideAngular(() => {
          fromEvent(this.searchEl()?.nativeElement, 'input').pipe(map(event => event.target.value)).pipe(debounceTime(this.debounceTime())).pipe(distinctUntilChanged()).subscribe({
            next: () => {
              this.searchText.set(this.searchEl()?.nativeElement.value);
            }
          });
          fromEvent(this.searchEl()?.nativeElement, 'search').pipe(debounceTime(900)).subscribe({
            next: () => {
              if (this.searchEl()?.nativeElement.value) {
                this.searchEnd.emit(this.searchEl()?.nativeElement.value);
              }
            }
          });
        });
        this.initialized = true;
      }
    }
    onFocusClicked() {
      this.searchEl()?.nativeElement.focus();
    }
    handleClickOnTrailingIcon() {
      this.searchText.set('');
      this.tempSearchText.set('');
      this.trailingIconClicked.emit();
    }
    static {
      this.ɵfac = function NgxSearchBoxComponent_Factory(t) {
        return new (t || NgxSearchBoxComponent)(i0.ɵɵdirectiveInject(i0.NgZone));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxSearchBoxComponent,
        selectors: [["ngx-search-box"]],
        viewQuery: function NgxSearchBoxComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.searchEl, _c0, 5);
            i0.ɵɵviewQuerySignal(ctx.focusButton, _c1, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance(2);
          }
        },
        inputs: {
          searchText: [i0.ɵɵInputFlags.SignalBased, "searchText"],
          isLoading: [i0.ɵɵInputFlags.SignalBased, "isLoading"],
          debounceTime: [i0.ɵɵInputFlags.SignalBased, "debounceTime"],
          mode: [i0.ɵɵInputFlags.SignalBased, "mode"],
          placeHolder: [i0.ɵɵInputFlags.SignalBased, "placeHolder"],
          autoFocus: [i0.ɵɵInputFlags.SignalBased, "autoFocus"],
          height: [i0.ɵɵInputFlags.SignalBased, "height"],
          leadingIcon: [i0.ɵɵInputFlags.SignalBased, "leadingIcon"]
        },
        outputs: {
          searchText: "searchTextChange",
          leadingIconClicked: "leadingIconClicked",
          trailingIconClicked: "trailingIconClicked",
          clicked: "clicked",
          searchEnd: "searchEnd"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 1,
        consts: [["searchEl", ""], ["focusButton", ""], [1, "search-container", "pr-medium", "pl-minus", "d-flex", "align-items-center", "justify-content-start", "radius-giant", "gap-small", "w-100", "rtl", 3, "click", "ngStyle"], [1, "search-container-iconbox", "leading", "h-100", "d-flex", "align-items-center", "justify-content-center", "cursor-pointer", "text-onback-high"], [1, "search-container-inputbox", "cursor-pointer", "h-100", "d-flex", "align-items-center", "justify-content-center"], ["type", "search", 3, "ngModelChange", "ngModel", "placeholder"], [1, "search-container-iconbox", "trailing", "h-100", "d-flex", "align-items-center", "justify-content-center", "cursor-pointer", "text-onback-high"], [2, "display", "none", 3, "click"], [1, "search-container-iconbox", "leading", "h-100", "d-flex", "align-items-center", "justify-content-center", "cursor-pointer", "text-onback-high", 3, "click"], [3, "iconSize", "name", "type"], [1, "search-container-iconbox", "trailing", "h-100", "d-flex", "align-items-center", "justify-content-center", "cursor-pointer", "text-onback-high", 3, "click"], [1, "w-100"], [3, "height", "classes"]],
        template: function NgxSearchBoxComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, NgxSearchBoxComponent_Conditional_0_Template, 8, 10)(1, NgxSearchBoxComponent_Conditional_1_Template, 2, 2);
          }
          if (rf & 2) {
            i0.ɵɵconditional(0, !ctx.isLoading() ? 0 : 1);
          }
        },
        dependencies: [FormsModule, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgModel, NgxSkeletonLoadingComponent, NgxIcon, NgStyle],
        styles: [".search-container[_ngcontent-%COMP%]{position:relative;direction:rtl}.search-container-iconbox[_ngcontent-%COMP%]{z-index:2}.search-container-inputbox[_ngcontent-%COMP%]{flex-grow:1}.search-container-inputbox-input[_ngcontent-%COMP%]{z-index:1;position:absolute;inset:0;padding:0 44px 0 40px;background-color:var(--surface-elevated);transition:.2s;border-color:transparent}.search-container-inputbox-input.section[_ngcontent-%COMP%]{background-color:var(--surface-back)}.search-container-inputbox-input[_ngcontent-%COMP%]:focus, .search-container-inputbox-input[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:focus-visible, .search-container-inputbox-input[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:active, .search-container-inputbox-input[_ngcontent-%COMP%]   [_ngcontent-%COMP%]:focus-within{outline:none!important;background-color:var(--surface-brand-tint);border-color:var(--border-brand)}.search-container-inputbox-input[_ngcontent-%COMP%]::placeholder{color:var(--text-onback-low)}input[_ngcontent-%COMP%]:-webkit-autofill, input[_ngcontent-%COMP%]:-webkit-autofill:hover, input[_ngcontent-%COMP%]:-webkit-autofill:focus, textarea[_ngcontent-%COMP%]:-webkit-autofill, textarea[_ngcontent-%COMP%]:-webkit-autofill:hover, textarea[_ngcontent-%COMP%]:-webkit-autofill:focus, select[_ngcontent-%COMP%]:-webkit-autofill, select[_ngcontent-%COMP%]:-webkit-autofill:hover, select[_ngcontent-%COMP%]:-webkit-autofill:focus{-webkit-box-shadow:0 0 0px 1000px #ffffff inset!important}input[type=search][_ngcontent-%COMP%]::-webkit-search-decoration, input[type=search][_ngcontent-%COMP%]::-webkit-search-cancel-button, input[type=search][_ngcontent-%COMP%]::-webkit-search-results-button, input[type=search][_ngcontent-%COMP%]::-webkit-search-results-decoration{-webkit-appearance:none}"],
        changeDetection: 0
      });
    }
  }
  return NgxSearchBoxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-search-box
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxSearchBoxComponent };
